import { Checkbox, Form, Input, Select } from "antd";

export default function CreditBureauInfoStep({ title, type }) {
  return (
    <>
      <Form.Item name={[type, "id"]} hidden>
        <Input />
      </Form.Item>
      <Form.Item valuePropName="checked" name={[type, "isEnabled"]}>
        <Checkbox>{`Report this company's data to ${title}`}</Checkbox>
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) =>
          prevValues[type]?.isEnabled !== currentValues[type]?.isEnabled
        }
      >
        {({ getFieldValue }) => {
          const isEnabled = getFieldValue([type, "isEnabled"]);
          return (
            <>
              <Form.Item
                name={[type, "programId"]}
                label="Program Identifier"
                rules={[{ required: isEnabled, message: "Program Identifier is required" }]}
              >
                <Input placeholder="Enter program identifier..." />
              </Form.Item>
              <Form.Item
                name={[type, "identificationNumber"]}
                label="Identification Number"
                rules={[{ required: isEnabled, message: "Identification Number is required" }]}
              >
                <Input placeholder="Enter identification number..." />
              </Form.Item>
              <Form.Item
                name={[type, "autoGenerationSchedule"]}
                label="Credit Reports Generation Schedule"
              >
                <Select
                  placeholder="Select schedule for generating reports automatically..."
                  options={[
                    { label: "Every 2nd Friday of the month", value: "every_2nd_friday" },
                    { label: "Every 4th Friday of the month", value: "every_4th_friday" },
                  ]}
                  mode="multiple"
                  popupMatchSelectWidth={false}
                  allowClear
                  maxTagTextLength={20}
                />
              </Form.Item>
            </>
          );
        }}
      </Form.Item>
    </>
  );
}
